import { OrderedList as ChakraOrderedList } from '@chakra-ui/react';

type OrderedListProps = React.ComponentProps<typeof ChakraOrderedList>;

const OrderedList = ({ children, ...props }: Readonly<OrderedListProps>) => {
  return <ChakraOrderedList {...props}>{children}</ChakraOrderedList>;
};

export default OrderedList;
